<template>
<v-container fluid>

  <v-snackbar
    v-model="snackbar"
    :color="snackbarColor"
    :top="true"
    :right="true"
    :timeout="0"
    absolute
    auto-height
  >
    {{ message }}
    <v-btn
      dark
      flat
      @click="snackbar = false"
    >
      CLOSE
    </v-btn>
  </v-snackbar>
<!--<v-snackbar-->
<!--  v-model="snackbar"-->
<!--  :color="snackbarColor"-->
<!--  top-->
<!--  right-->
<!--  :timeout="-1"-->
<!--  >-->
<!--  {{ message }}-->
<!--  <v-btn-->
<!--    dark-->
<!--    text-->
<!--    @click="snackbar = false"-->
<!--  >-->
<!--    CLOSE-->
<!--  </v-btn>-->
 <!-- </v-snackbar> -->
  <v-layout class="mt-14">
  <v-flex xs12>
    <div :class="paginatedFiles.length === 7 ? 'viewfarmer_box' : 'viewfarmer_box_empty'">
      <v-card-text>
    <v-layout>
      <v-flex xs3>
      <span class="accent--text" style="font-size: 14px; font-weight:700;"> Uploaded Farmers </span>
    </v-flex>
    <v-spacer>
    </v-spacer>
    <v-flex xs3>
       <v-text-field label="Search" v-model="search">
       </v-text-field>
     </v-flex>
     </v-layout>
      <table class="table">
         <thead class="thead">
          <tr>
            <th scope="col">Grower Code</th>
            <th scope="col">Name</th>
            <th scope="col">ID Number</th>
            <th scope="col">Member Number</th>
            <th scope="col">Mobile Number</th>
            <th scope="col">Acreage</th>
            <th scope="col">Farmer Type</th>
            <th scope="col">Actions</th>
            </tr>
        </thead>
        <tbody>
        <tr v-for="farmer in filteredList" v-bind:key="farmer.id">
          <td> {{ farmer.organisationCode  }} </td>
          <td> {{ farmer.firstName }} {{ farmer.middleName }} {{ farmer.lastName }} </td>
          <td> {{ farmer.farmerId }} </td>
          <td> {{ farmer.memberNumber }} </td>
          <td>{{ farmer.mobileNumber }}</td>
          <td>{{ farmer.acreage }}</td>
          <td>{{ farmer.farmerTypeName }}</td>
          <td class="actions">
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
               <v-btn
                color="primary"
                dark
                v-on="on"
                text
                icon
                class="actions"
              >
                <v-icon class="secondary--text"> more_horiz </v-icon>
              </v-btn>
              </template>
              <v-list>
                <v-list-item @click="showEditDialog(farmer)" v-if="canEditFarmer()">
                  <v-list-item-title> Edit </v-list-item-title>
                </v-list-item>
                <v-list-item :to="`/farmers/loan/history/${farmer.organizationId}/${farmer.id}`">
                  <v-list-item-title> Loan History </v-list-item-title>
                </v-list-item>
                <v-list-item @click="viewBankDetails(farmer)">
                  <v-list-item-title> Bank Details </v-list-item-title>
                </v-list-item>
                <v-list-item @click="downloadStatement(farmer)">
                  <v-list-item-title> Download Statement </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </td>
        </tr>
        </tbody>
      </table>
      </v-card-text>
      <v-card-actions>
        <span class="paginationtext"> Showing {{ page }} of {{ numberOfLinks }} pages </span>
        <v-spacer></v-spacer>
        <v-pagination
        v-model="page"
        :length="numberOfLinks"
        color="secondary"
                class="accent--text logoutbtn"
      ></v-pagination>
      </v-card-actions>
    </div>
  </v-flex>
  </v-layout>

  <v-dialog v-model="bankDetailsDialog" persistent max-width="500" v-if="this.farmer !== null">
    <v-card>
      <v-card-title class="headline primary--text">Bank Details</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="6" md="6">
            <h5> Account Name: </h5>
          </v-col>
          <v-col cols="6" md="6">
            {{ this.farmer !== null ? this.farmer.accountName : ''}}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6">
            <h5> Account No: </h5>
          </v-col>
          <v-col cols="6" md="6">
           {{ this.farmer !== null ? this.farmer.accountNumber : ''}}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6">
            <h5>  Bank Name: </h5>
          </v-col>
          <v-col cols="6" md="6">
            {{ this.farmer !== null ? this.farmer.institutionName : '' }}
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="closeBankDialog">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="editDialog" persistent max-width="700">
    <v-card>
      <v-card-title class="headline primary--text">Edit Farmer</v-card-title>
      <v-card-text>
        <v-form ref="editform" v-model="valid" lazy-validation>
        <v-layout v-if="farmer.farmerTypeName === 'FCS_FARMER'">
        <v-flex xs5>
          <v-text-field label="First Name" v-model="farmer.firstName"></v-text-field>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex xs5>
          <v-text-field label="Last Name" v-model="farmer.lastName"></v-text-field>
        </v-flex>
       </v-layout>
       <v-layout v-if="farmer.farmerTypeName === 'FCS_FARMER'">
         <v-flex xs5>
           <v-text-field label="Middle Name" v-model="farmer.middleName"></v-text-field>
         </v-flex>
         <v-spacer></v-spacer>
        <v-flex xs5>
          <v-text-field label="Farmer Id" v-model="farmer.farmerId"></v-text-field>
        </v-flex>
       </v-layout>
          <v-layout v-if="farmer.farmerTypeName === 'FCS_FARMER_COMPANY'">
            <v-flex xs5>
              <v-text-field label="First Name" v-model="farmer.firstName"></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs5>
              <v-text-field label="Last Name" v-model="farmer.farmerId"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout v-if="farmer.farmerTypeName === 'FCS_FARMER_COMPANY'">
            <v-flex xs5>
              <v-text-field label="Company Name" v-model="farmer.companyName"></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs5>
              <v-text-field label="Company Reg Number" v-model="farmer.companyRegNumber"></v-text-field>
            </v-flex>

          </v-layout>
       <v-layout>
         <v-flex xs5>
           <v-text-field label="Mobile No" v-model="farmer.mobileNumber"></v-text-field>
         </v-flex>
         <v-spacer></v-spacer>
        <v-flex xs5>
          <v-text-field label="Member  No" v-model="farmer.memberNumber"></v-text-field>
        </v-flex>

         </v-layout>
           <v-layout>

        <v-flex xs5>
          <v-text-field label="Gender" v-model="farmer.gender"></v-text-field>
        </v-flex>
        </v-layout>
        <v-layout>
        <v-flex xs5>
          <v-autocomplete v-model="farmer.institutionCode" :items="banks" item-text="institutionName" item-value="institutionCode" label="Payment Institution"></v-autocomplete>
        </v-flex>
        <v-spacer></v-spacer>
          <v-flex xs5>
            <v-text-field label="Payment Institution Account" v-model="farmer.accountNumber"></v-text-field>
          </v-flex>
        </v-layout>

       </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" text @click="editDialog = false">Close</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="editRecord">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'

export default {
	name: 'viewfarmers',
	data: function () {
		return {
			valid: true,
			message: '',
			snackbar: false,
			snackbarColor: '',
			farmers: [],
			totalFarmers: 0,
			pagination: { sortBy: 'id', descending: true },
			search: '',
			paginatedFiles: [],
			numberOfLinks: 0,
			numberOfItemsPerPage: 7,
			page: 1,
			farmerBankDetail: null,
			editDialog: false,
			bankDetailsDialog: false,
			farmer: { farmerBankDetail: { bank: {} } },
			banks: [],
			permissions: [],
			organisationType: '',
			organisationId: ''

		}
	},
	mounted () {
		this.getLoggedInUser()
		this.getFarmers()
		this.getBanks()
		this.permissions = store.state.user.roleId.permissions
	},
	watch: {
		farmers () {
			this.paginatedFiles = this.paginationMethod(this.farmers, 1, this.numberOfItemsPerPage)
			this.numberOfLinks = Math.ceil(this.farmers.length / this.numberOfItemsPerPage)
		},
		page: function (val) {
			this.paginatedFiles = this.paginationMethod(this.farmers, val, this.numberOfItemsPerPage)
		}
	},
	computed: {
		filteredList: function () {
			if (this.search === '') {
				return this.paginatedFiles
			} else {
				return this.farmers.filter(farmer => { return (farmer.firstName !== null ? farmer.firstName.toLowerCase().includes(this.search.toLowerCase()) : ''.toLowerCase().includes(this.search.toLowerCase())) || (farmer.lastName === null ? ''.toLowerCase().includes(this.search.toLowerCase()) : farmer.lastName.toLowerCase().includes(this.search.toLowerCase())) || farmer.farmerId.toLowerCase().includes(this.search.toLowerCase()) || farmer.mobileNumber.includes(this.search) || farmer.memberNumber.includes(this.search) })
			}
		}
	},
	methods: {
		getLoggedInUser () {
			this.theUser = JSON.parse(localStorage.getItem('user'))
			console.log('user ===>> ', this.theUser)
			this.organisationType = this.theUser.organisation.organisationType.name
			this.organisationId = this.theUser.organisation.id
			// this.curUserN = this.curUser.firstName
		},
		paginationMethod (items, pageNumber, limitPerPage) {
			pageNumber = pageNumber - 1
			const from = pageNumber * limitPerPage
			let to = (pageNumber + 1) * limitPerPage
			if (to >= items.length) {
				to = items.length
			}
			return items.slice(from, to)
		},
		hasPerm (permission) {
			return this.permissions.includes(permission)
		},
		getFarmers () {
			const url = config.serverURI + '/upload/cherry/getFarmers/' + this.organisationId
			axios.get(url)
				.then(response => {
					console.log(response.data)
					this.farmers = response.data
				})
				.catch(error => {
					console.log('error', error.response)
				})
		},
		viewBankDetails (item) {
			this.bankDetailsDialog = true
			this.farmer = item
			// this.farmerBankDetail = item.farmerBankDetail
			console.log(this.farmer)
		},
		closeBankDialog () {
			// this.farmer = null
			this.bankDetailsDialog = false
		},
		showEditDialog (farmer) {
			this.editDialog = true
			this.farmer = farmer
		},
		editRecord () {
			if (this.$refs.editform.validate()) {
				const url = config.serverURI + '/farmer/edit'
				axios.post(url, {
					id: this.farmer?.id,
					firstName: this.farmer?.firstName,
					lastName: this.farmer?.lastName,
					middleName: this.farmer?.middleName,
					memberNumber: this.farmer?.memberNumber,
					gender: this.farmer?.gender,
					farmerId: this.farmer?.farmerId,
					growerId: this.farmer?.organizationId,
					bankCode: this.farmer?.institutionCode,
					account: this.farmer?.accountNumber,
					mobileNumber: this.farmer?.mobileNumber,
					companyName: this.farmer?.companyName,
					companyRegistrationNumber: this.farmer?.companyRegNumber

				})
					.then(response => {
						// console.log('Response', response.data)
						if (response.data.error !== false) {
							this.message = response.data.message
							this.snackbar = true
							this.snackbarColor = 'error'
							console.log('Error is ' + this.message)
							return
						}
						this.$refs.editform.resetValidation()
						this.message = response.data.message
						this.snackbar = true
						this.snackbarColor = 'primary'
						this.editDialog = false
					})
					.catch(error => {
						console.log('error', error.response)
						this.message = error.response.message
						this.snackbar = true
						this.snackbarColor = 'error'
					})

				this.getFarmers()
			}
		},
		getBanks () {
			const url = config.serverURI + '/payment/institutions'
			axios.get(url)
				.then(response => {
					this.banks = response.data
				})
				.catch(error => {
					console.log('error', error.response)
				})
		},
		canEditFarmer () {
			return this.hasPerm('CAN_UPDATE_FARMER')
		},
		downloadStatement (farmer) {
			const url = config.serverURI + `/farmer/loan_statement/${farmer.organizationId}/${farmer.id}`
			this.loading = true
			axios({ url: url, method: 'GET', responseType: 'blob' })
				.then(response => {
					this.loading = false
					const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
					const link = document.createElement('a')
					link.href = url
					const itemFileName = `loanstatement_${farmer.id}.pdf`
					link.setAttribute('download', itemFileName)
					document.body.appendChild(link)
					link.click()
				})
				.catch(error => {
					this.loading = false
					console.log('error', error.response)
				})
		}
	}
}

</script>
<style>
.viewfarmer_box_empty {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}
.viewfarmer_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}
.catalogue_box:after, .catalogue_box:before {
  right: 100%;
  top: 17%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.catalogue_box:after {
  border-color: rgba(255, 255, 255, 0);
  border-right-color: #fff;
  border-width: 20px;
  margin-top: -20px;
}
.catalogue_box:before {
  border-color: rgba(112, 112, 112, 0);
  border-right-color: #707070;
  border-width: 21px;
  margin-top: -21px;
}

.thead {
  background-color: #00513B !important;
  color: white;
  font-size: 12px;
}

.table  tbody  tr >  td.actions {
  font-size: 20px !important;
  color: #733D29 !important;
  padding-top: 0px;
}
.pagination {
  background-color: red;
}
.paginationtext {
  color: #733D29;
}

.pagination>li>a,
.pagination>li>span {
  border: 1px solid #F2D0A7;
  color: #733D29;
}
.pagination>li.active>.page-link {
  background: #00513B;
  color: #fff;
}
</style>
